import jsPDF from 'jspdf';
import { MailPiece } from '../../../services/SplService';
import { formatCityStateZip } from '../../../util/AddressUtils';

type GenerateAddressInfoParams = {
  pdf: jsPDF;
  mailPiece: MailPiece | null;
  maxLength: number;
};

/**
 * Generate address fields to add to PDF.
 */
export default function generateAddressInfo(params: GenerateAddressInfoParams) {
  const { pdf, mailPiece, maxLength } = params;

  return [
    ...(mailPiece?.name ? pdf.splitTextToSize(`${mailPiece.name}`, maxLength) : []),
    ...(mailPiece?.businessName ? pdf.splitTextToSize(`${mailPiece.businessName}`, maxLength) : []),
    ...(mailPiece?.address1 ? pdf.splitTextToSize(`${mailPiece.address1}`, maxLength) : []),
    ...(mailPiece?.address2 ? pdf.splitTextToSize(`${mailPiece.address2}`, maxLength) : []),
    ...(mailPiece?.address3 ? pdf.splitTextToSize(`${mailPiece.address3}`, maxLength) : []),
    ...pdf.splitTextToSize(formatCityStateZip(mailPiece?.city || '', mailPiece?.state || '', mailPiece?.zip5d, mailPiece?.zipPlus4), maxLength)
  ];
}
